// V2 Shared — decks shared with the signed-in user. Internal (user-to-user)
// sharing is a later backend phase; until then this surfaces a clear empty
// state rather than pretending. Reuses home.css (.library/.shared-list). Light
// DOM; responsive via the shared library layout.

import { LitElement, html, type TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { navigate } from '../lib/router-state';
import { setPageTitle } from '../lib/page-title';

@customElement('shared-page')
export class SharedPage extends LitElement {
  protected createRenderRoot(): HTMLElement {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    setPageTitle('Shared with me', 'Decks your colleagues have shared with you.');
  }

  render(): TemplateResult {
    return html`
      <div class="home">
        <section class="tpl-hero">
          <div class="hero-eyebrow">✦ Shared with me</div>
          <h1 class="tpl-hero-title">Decks others shared.</h1>
          <p class="tpl-hero-sub">Decks your colleagues have given you access to. Open to view or pick up where they left off.</p>
        </section>
        <div class="lib-empty">
          <span class="lib-empty-ico">👥</span>
          <div>Nothing has been shared with you yet.</div>
          <div class="faint" style="font-size:var(--fs-body-sm)">When a colleague shares a deck with you it appears here. Share your own from a deck's menu.</div>
          <button class="btn btn--ghost btn--sm" style="margin-top:10px" @click=${() => navigate('/library')}>Go to your library</button>
        </div>
      </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'shared-page': SharedPage }
}
